"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports.default = void 0;
var _utils = require("./utils");
Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _utils[key];
    }
  });
});
/**
 *
 *  Apollo Client InvalidationPolicies
 *
 *  Invalidation policies enable side-effects when types are read, written or evicted from the Apollo 3 cache. According
 *  to the documentation at: https://github.com/NerdWalletOSS/apollo-cache-policies
 */
var _default = exports.default = {
  // ...
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfdXRpbHMiLCJyZXF1aXJlIiwiT2JqZWN0Iiwia2V5cyIsImZvckVhY2giLCJrZXkiLCJwcm90b3R5cGUiLCJoYXNPd25Qcm9wZXJ0eSIsImNhbGwiLCJfZXhwb3J0TmFtZXMiLCJleHBvcnRzIiwiZGVmaW5lUHJvcGVydHkiLCJlbnVtZXJhYmxlIiwiZ2V0IiwiX2RlZmF1bHQiLCJkZWZhdWx0Il0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ludmFsaWRhdGlvbi1wb2xpY2llcy9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqXG4gKiAgQXBvbGxvIENsaWVudCBJbnZhbGlkYXRpb25Qb2xpY2llc1xuICpcbiAqICBJbnZhbGlkYXRpb24gcG9saWNpZXMgZW5hYmxlIHNpZGUtZWZmZWN0cyB3aGVuIHR5cGVzIGFyZSByZWFkLCB3cml0dGVuIG9yIGV2aWN0ZWQgZnJvbSB0aGUgQXBvbGxvIDMgY2FjaGUuIEFjY29yZGluZ1xuICogIHRvIHRoZSBkb2N1bWVudGF0aW9uIGF0OiBodHRwczovL2dpdGh1Yi5jb20vTmVyZFdhbGxldE9TUy9hcG9sbG8tY2FjaGUtcG9saWNpZXNcbiAqL1xuXG5leHBvcnQgKiBmcm9tICcuL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQge1xuICAvLyAuLi5cbn07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFRQSxJQUFBQSxNQUFBLEdBQUFDLE9BQUE7QUFBQUMsTUFBQSxDQUFBQyxJQUFBLENBQUFILE1BQUEsRUFBQUksT0FBQSxXQUFBQyxHQUFBO0VBQUEsSUFBQUEsR0FBQSxrQkFBQUEsR0FBQTtFQUFBLElBQUFILE1BQUEsQ0FBQUksU0FBQSxDQUFBQyxjQUFBLENBQUFDLElBQUEsQ0FBQUMsWUFBQSxFQUFBSixHQUFBO0VBQUEsSUFBQUEsR0FBQSxJQUFBSyxPQUFBLElBQUFBLE9BQUEsQ0FBQUwsR0FBQSxNQUFBTCxNQUFBLENBQUFLLEdBQUE7RUFBQUgsTUFBQSxDQUFBUyxjQUFBLENBQUFELE9BQUEsRUFBQUwsR0FBQTtJQUFBTyxVQUFBO0lBQUFDLEdBQUEsV0FBQUEsQ0FBQTtNQUFBLE9BQUFiLE1BQUEsQ0FBQUssR0FBQTtJQUFBO0VBQUE7QUFBQTtBQVJBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBTkEsSUFBQVMsUUFBQSxHQUFBSixPQUFBLENBQUFLLE9BQUEsR0FVZTtFQUNiO0FBQUEsQ0FDRCIsImlnbm9yZUxpc3QiOltdfQ==